import { assocPath, map, modify } from 'ramda';

export const handleChangeDiscount = (form, value) => {
  const packs = form.watch('offer.packs');
  const updatedPacks = map((pack) => {
    return modify(
      'pricings',
      map((pricing) => assocPath(['waiverRequests', 0, 'code'], value, pricing)),
      pack
    );
  }, packs);

  form.setValue('offer.packs', updatedPacks);
};
